import type { ReactNode } from "react";

import type { OneOrMany } from "~/tools/one-or-many";

/**
 * React.Children.map does not pick up functions as children,
 * so the workaround is to map over children manually.
 */
export function mapChildren<TChild, TResult = ReactNode>(
	children: OneOrMany<TChild>,
	fn: (child: TChild, index: number) => TResult,
): Array<TResult> {
	return [children].flat().map(fn);
}
